// @flow
import _ from 'lodash'
import React, { Component } from 'react'
import { translations, translateFunc } from '../../shared/localize'
import ProviderStatus from './ProviderStatus'
import StateHumanHint from './StateHumanHint'
import styled, { type StyledComponent } from 'styled-components'
import { offColor } from '../controls/colors'

const ProviderStatusesWrapper: StyledComponent<Object, any, any> = styled.div`
  .off {
    div,
    a {
      color: ${offColor};
      border-color: ${offColor};
    }
  }
`

const ProviderStatusesLine: StyledComponent<Object, any, any> = styled.div`
  margin-top: 5px;
`

type Props = {|
  id: number,
  rejectedStateConstant: string,
  noBudgetStateConstant: string,
  suspendedStateConstant: string,
  unconnectedStateConstant: string,
  errorStateConstant: string,
  isActive: boolean,
  isAudiencePaused: boolean,
  isAudienceInactive: boolean,
  isAudienceComplete: boolean,
  noBudgetHelpPath: string,
  editPath: string,
  connectPath: string,
  providerStates: Object,
  decorateHumanDescription: string,
  onProviderStatusesChange: Function,
  hidePlayPauseButtons: boolean
|}

const t = translateFunc(translations.provider_statuses)

export default class ProviderStatuses extends Component<Props> {
  render() {
    if (this.props.isActive) {
      return this.renderActive()
    } else {
      return (
        <StateHumanHint
          triggerText={t('turned_off_label')}
          hintText={t('turned_off_description')}
          styleCode="off"
        />
      )
    }
  }

  renderActive() {
    const {
      id,
      isAudiencePaused,
      isAudienceInactive,
      isAudienceComplete,
      decorateHumanDescription,
      providerStates,
      rejectedStateConstant,
      noBudgetStateConstant,
      suspendedStateConstant,
      unconnectedStateConstant,
      errorStateConstant,
      noBudgetHelpPath,
      editPath,
      connectPath,
      hidePlayPauseButtons
    } = this.props

    if (isAudiencePaused || isAudienceInactive || isAudienceComplete) {
      let triggerText = t('paused_label')
      let hintText = t('paused_description')
      let style = 'alert'

      if (isAudienceInactive) {
        triggerText = t('inactive_label')
        hintText = t('inactive_description')
      }
      if (isAudienceComplete) {
        triggerText = t('complete_label')
        hintText = decorateHumanDescription
        style = 'muted'
      }
      return <StateHumanHint triggerText={triggerText} hintText={hintText} styleCode={style} />
    }

    return (
      <ProviderStatusesWrapper>
        {_.map(providerStates, (providerData, provider: string) => (
          <ProviderStatusesLine key={provider}>
            <ProviderStatus
              id={id}
              provider={provider}
              state={providerData['state']}
              description={providerData['description']}
              activateUrl={providerData['activateUrl']}
              deactivateUrl={providerData['deactivateUrl']}
              rejectedStateConstant={rejectedStateConstant}
              noBudgetStateConstant={noBudgetStateConstant}
              suspendedStateConstant={suspendedStateConstant}
              unconnectedStateConstant={unconnectedStateConstant}
              errorStateConstant={errorStateConstant}
              noBudgetHelpPath={noBudgetHelpPath}
              editPath={editPath}
              connectPath={connectPath}
              onChange={(data) => this.providerDataChanged(data)}
              hidePlayPauseButtons={hidePlayPauseButtons}
            />
          </ProviderStatusesLine>
        ))}
      </ProviderStatusesWrapper>
    )
  }

  providerDataChanged(data: Object) {
    const { onProviderStatusesChange } = this.props
    onProviderStatusesChange && onProviderStatusesChange(data)
  }
}
